import { format } from "date-fns";
import { DateFilterState } from "../store/slices/dateFilterSlice";
import { DateFilterParams } from "../features/messages/messagesApiSlice";
import { useAppSelector } from "../store/store";

/**
 * Converts the global date filter state to API parameters
 */
export const getDateFilterParams = (
  dateFilter: DateFilterState
): DateFilterParams => {
  if (dateFilter.mode === "range" && dateFilter.dateRange) {
    return {
      mode: "range",
      startDate: format(dateFilter.dateRange.start, "yyyy-MM-dd"),
      endDate: format(dateFilter.dateRange.end, "yyyy-MM-dd"),
    };
  } else {
    const selectedDateStr = format(dateFilter.selectedDate, "yyyy-MM-dd");
    return {
      mode: "single",
      date: selectedDateStr,
    };
  }
};

/**
 * Hook to get current date filter parameters for API calls
 */

export const useDateFilterParams = (): DateFilterParams => {
  const dateFilter = useAppSelector((state) => state.dateFilter);
  return getDateFilterParams(dateFilter);
};

/**
 * Converts the global date filter state to startDate/endDate format for new analytics endpoints
 */
export const getAnalyticsDateParams = (
  dateFilter: DateFilterState
): { startDate: string; endDate: string } => {
  if (dateFilter.mode === "range" && dateFilter.dateRange) {
    return {
      startDate: format(dateFilter.dateRange.start, "yyyy-MM-dd"),
      endDate: format(dateFilter.dateRange.end, "yyyy-MM-dd"),
    };
  } else {
    // For single date mode, set both startDate and endDate to the same date
    const selectedDateStr = format(dateFilter.selectedDate, "yyyy-MM-dd");
    return {
      startDate: selectedDateStr,
      endDate: selectedDateStr,
    };
  }
};

/**
 * Hook to get date parameters in startDate/endDate format for new analytics endpoints
 */
export const useAnalyticsDateParams = (): {
  startDate: string;
  endDate: string;
} => {
  const dateFilter = useAppSelector((state) => state.dateFilter);
  return getAnalyticsDateParams(dateFilter);
};
